import { NavigationBar, ProfileMenu } from '@barracuda-internal/bds-core';
import { useNavigate } from 'react-router-dom';
import SvgFaviconApp from '@barracuda-internal/bds-core/dist/Logos/Favicons/FaviconApp';
import { TextSnippet, PermIdentity } from '@mui/icons-material/';
import {
  OpenInNew,
  ExitToApp,
} from '@barracuda-internal/bds-core/dist/Icons/Core';

const NavigationPanel = ({
  email,
  name,
  logout,
  serial,
  build,
  authenticated
}) => {
  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const nav_options = !authenticated ? [] : [
        {
            name: 'Profile',
            initials: generateInitials(name),
            menu: (
                <ProfileMenu
                    initials={generateInitials(name)}
                    name={name}
                    email={email}
                    menuItems={[
                        {
                            name: 'Manage account',
                            href: 'https://login.barracudanetworks.com/',
                            openInNewTab: true,
                            icon: <PermIdentity />,
                            endIcon: <OpenInNew />,
                        },
                        {
                            name: 'Privacy Policy',
                            href: 'https://www.barracuda.com/legal/privacy',
                            openInNewTab: true,
                            icon: <TextSnippet />,
                        },
                        {
                            name: 'Sign Out',
                            onClick: logout,
                            icon: <ExitToApp />,
                        },
                    ]}
                    footer={{
                        serial: serial,
                        version: build,
                    }}
                />
            ),
        },
  ];
  const route_options = !authenticated ? [] : [
          // {
          //   path: '/scan',
          //   icon: <ExitToApp />, 
          //   name: 'Scan',
          // },
          // {
          //   path: '/scan-result/kunal-test-uuid',
          //   icon: <ExitToApp />, 
          //   name: 'Scan Result',
          // }
        ];
  return (
    <>
      <NavigationBar
        title="WAFaaS"
        logo={<SvgFaviconApp />}
        options={nav_options}
        routes={ route_options }
        currentPath={pathname}
        onNavigate={(path) => {
            navigate(path);
        }}
      />
    </>
  );
};
export default NavigationPanel;

function generateInitials(name) {
  if (!name) return '';

  const parts = String(name).trim().split(/\s+/).filter(Boolean);

  // Handle empty string after trimming
  if (parts.length === 0) return '';

  // For single word
  if (parts.length === 1) {
    const word = parts[0];
    // If word has at least 2 characters, take first two
    if (word.length >= 2) {
      return word.slice(0, 2).toUpperCase();
    }
    // If word has only 1 character, return just that
    return word[0].toUpperCase();
  }

  // For multiple words, take first letter of first two words
  return (parts[0][0] + parts[1][0]).toUpperCase();
}